import React from "react";

const benefitsData = [
  {
    heading: "Clear path",
    desc: "For the short, medium, and long-term future of your organisation, so you can build upon a shared vision.",
  },
  {
    heading: "Confident decisions",
    desc: "Feel assured about the technology solutions and execution plans for your digital transformation.",
  },
  {
    heading: "Create value",
    desc: "For your organisation and customers. Capitalise on new opportunities created through your chosen technology",
  },
];

const Benefits = () => {
  return (
    <div id="benefits" className="bg-[#4f1951] dark:bg-dark py-[150px]   ">
      <div className="w-full sm:w-[90%] mx-auto flex flex-col justify-center items-center gap-[100px] relative">
        <div className="relative text-center">
          <h1 className="text-4xl  font-extrabold md:text-7xl font-mono text-center text-white leading-normal">
            Benefits
          </h1>
          <div
            className="dark:bg-custom-gradient"
            style={{
              position: "absolute",
              width: "320.95px",
              height: "157.05px",
              left: "50%", // Center horizontally
              top: "50%", // Center vertically
              transform: "translate(-50%, -50%) matrix(1, 0, -0.03, 1, 0, 0)", // Adjust for precise positioning
              opacity: 0.2,
              filter: "blur(34px)",
              borderRadius: "50%",
              zIndex: "0", // Ensure it's behind the text
            }}
          ></div>
        </div>

        <div className="grid grid-cols-1 px-5 sm:grid-cols-2 gap-10 lg:grid-cols-3 ">
          {benefitsData.map((benefit, index) => (
            <div className="flex flex-col justify-start gap-4" key={index}>
              <h1 className="text-white text-3xl font-sans font-semibold">
                {benefit.heading}
              </h1>
              <p className="text-white  font-serif font-light w-[90%]">
                {benefit.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Benefits;
